"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var config_1 = require("@pbl/pbl-react-core/lib/config/config");
var types_1 = require("@pbl/pbl-react-core/lib/models/draws/types");
var DateTimeFormatter_1 = __importDefault(require("@pbl/pbl-react-core/lib/utils/DateTimeFormatter"));
var TimeUtil_1 = require("@pbl/pbl-react-core/lib/utils/TimeUtil");
var EntriesBox_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/draw/EntriesBox"));
var Icon_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/icon/Icon"));
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var React = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var colors_1 = __importDefault(require("../../assets/jss/colors"));
var constants_1 = __importDefault(require("../../config/constants"));
var TermsOfUseUpdateModal_1 = __importDefault(require("../../modules/SettingsWidget/profile/completeprofile/TermsOfUseUpdateModal"));
var actions_1 = require("../../redux/reducers/app/actions");
var actions_2 = require("../../redux/reducers/draws/actions");
var actions_3 = require("../../redux/reducers/opt-out/actions");
var actions_4 = require("../../redux/reducers/profile/actions");
var actions_5 = require("../../redux/reducers/super-bonus/actions");
var useDrawData_1 = require("../../shared/hooks/providers/useDrawData");
var useScrollToTop_1 = require("../../shared/hooks/useScrollToTop");
var framework_1 = require("../../widgets/framework");
var EligibleGames_1 = __importDefault(require("./components/EligibleGames"));
var styles_1 = require("./styles");
var PromotionDetailScreen = function (_a) {
    var _b, _c, _d, _e, _f;
    var identifier = _a.identifier, projectName = _a.projectName, hideEligibleGames = _a.hideEligibleGames, showSuperBonus = _a.showSuperBonus, titleComponent = _a.titleComponent;
    var theme = (0, core_1.useTheme)();
    var classes = (0, styles_1.styles)(theme)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var _g = React.useState(false), pendingRedirect = _g[0], setPendingRedirect = _g[1];
    var drawDetail = (0, react_redux_1.useSelector)(function (state) { return state.drawDetail; });
    var drawsData = (0, react_redux_1.useSelector)(function (state) { return state.draws; });
    var promotionData = (0, react_redux_1.useSelector)(function (state) { return state.promotionSuperBonus; });
    var preferences = (0, react_redux_1.useSelector)(function (state) { return state.optOutPreferences; }).preferences;
    var _h = (0, react_redux_1.useSelector)(function (state) { return state.authentication; }), account = _h.account, isLoggedIn = _h.isAuthenticated, isRestricted = _h.isRestricted;
    var checkTermsAndConditions = (0, react_redux_1.useSelector)(function (state) { return state.profile; }).checkTermsAndConditions;
    var _j = React.useState(null), prizeCheck = _j[0], setPrizeCheck = _j[1];
    var _k = React.useState(false), showError = _k[0], setShowError = _k[1];
    var _l = React.useState(false), showGiveawayPopup = _l[0], setShowGiveawayPopup = _l[1];
    var _m = React.useState(false), showWinnerDialog = _m[0], setShowWinnerDialog = _m[1];
    var _o = React.useState(false), showPrizesDialog = _o[0], setShowPrizesDialog = _o[1];
    var _p = React.useState(false), drawPrizeContentRetrieved = _p[0], setDrawPrizeContentRetrieved = _p[1];
    (0, useScrollToTop_1.useScrollToTop)();
    var _q = React.useState(false), showTermsOfUseUpdateModal = _q[0], setShowTermsOfUseUpdateModal = _q[1];
    var _r = React.useState(false), tosChecked = _r[0], setTosChecked = _r[1];
    var getGiveawayDrawDates = function (draw) {
        var _a, _b, _c;
        var drawStartDate = draw && draw.drawStart
            ? !!((_a = config_1.react_core_config.internalConfig.dateFormatter) === null || _a === void 0 ? void 0 : _a.drawStartEndDateFormat)
                ? DateTimeFormatter_1.default.getFormattedDateFromDateString('drawStartEndDateFormat', draw.drawStart)
                : (0, TimeUtil_1.formatLongMonthDayCommaYear)(draw.drawStart)
            : 'TBD';
        var drawEndDate = draw && draw.drawEnd
            ? !!((_b = config_1.react_core_config.internalConfig.dateFormatter) === null || _b === void 0 ? void 0 : _b.drawStartEndDateFormat)
                ? DateTimeFormatter_1.default.getFormattedDateFromDateString('drawStartEndDateFormat', draw.drawEnd)
                : (0, TimeUtil_1.formatLongMonthDayCommaYear)(draw.drawEnd)
            : 'TBD';
        var drawDate = draw && draw.draw
            ? !!((_c = config_1.react_core_config.internalConfig.dateFormatter) === null || _c === void 0 ? void 0 : _c.drawDrawDateFormat)
                ? DateTimeFormatter_1.default.getFormattedDateFromDateString('drawDrawDateFormat', draw.draw)
                : (0, TimeUtil_1.formatLongMonthDayCommaYear)(draw.draw)
            : 'TBD';
        return {
            drawStartDate: drawStartDate,
            drawEndDate: drawEndDate,
            drawDate: drawDate
        };
    };
    var selectedPromotion = drawsData.selectedPromotion, draws = drawsData.draws, loading = drawsData.loading, hasGiveawayEntry = drawsData.hasGiveawayEntry, giveawayDraws = drawsData.giveawayDraws, errorMessage = drawsData.errorMessage, giveawayErrorMessage = drawsData.giveawayErrorMessage;
    var optOutEntries = drawDetail.optOutEntries, giveawayDraw = drawDetail.giveawayDraw, giveawayEntries = drawDetail.giveawayEntries;
    var isGiveaway = (selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.promotionType) === types_1.PromotionType.GIVEAWAY;
    (0, useDrawData_1.useDrawData)(selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.id);
    React.useEffect(function () {
        if (showSuperBonus && (selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.id)) {
            dispatch((0, actions_2.fetchEligibleGames)(selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.id));
        }
    }, [selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.id]);
    React.useEffect(function () {
        if (draws && draws.length > 0 && !isGiveaway) {
            var drawIds = draws.map(function (draw) { return draw.id; });
            if (isLoggedIn) {
                dispatch((0, actions_3.fetchDrawOptOutPreference)(drawIds));
                if (showSuperBonus) {
                    dispatch((0, actions_5.fetchPromotionSuperBonusData)(drawIds));
                }
            }
        }
    }, [draws, showSuperBonus]);
    React.useEffect(function () {
        dispatch((0, actions_2.resetByPromotion)());
    }, []);
    React.useEffect(function () {
        if (!!selectedPromotion && selectedPromotion.promotionType) {
            if (isGiveaway) {
                clearInterval(prizeCheck);
                dispatch((0, actions_2.fetchGiveawayPromotionDraws)(parseInt(identifier.toString(), 0), 0, 10, 'asc'));
            }
            else {
                dispatch((0, actions_2.fetchDrawsByPromotion)(identifier));
            }
        }
        if (isLoggedIn && !checkTermsAndConditions && constants_1.default.CHECK_TERMS_AND_CONDITIONS_ENABLED) {
            setShowTermsOfUseUpdateModal(true);
        }
    }, [selectedPromotion]);
    React.useEffect(function () {
        if (isLoggedIn && giveawayDraws.length !== 0) {
            dispatch((0, actions_2.getGiveawayEntries)(identifier));
        }
    }, [giveawayDraws]);
    React.useEffect(function () {
        if (errorMessage) {
            setShowError(true);
        }
        else {
            setShowError(false);
        }
    }, [errorMessage]);
    var nowToday = (0, moment_timezone_1.default)();
    var ticketEntryText = '';
    var ticketEntryButtonDisabled = false;
    if (isGiveaway) {
        var isGiveawayEnded = giveawayDraws.every(function (d) { return !!d.drawEnd && (0, moment_timezone_1.default)(d.drawEnd).isBefore(nowToday); });
        var isGiveawayComingSoon = !giveawayDraws.length ||
            giveawayDraws.every(function (d) { return !!d.drawStart && (0, moment_timezone_1.default)(d.drawStart).isAfter(nowToday); }) ||
            (selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.isComingSoon());
        if (isGiveawayComingSoon) {
            ticketEntryText = t('giveaway.soon');
            ticketEntryButtonDisabled = true;
        }
        else if (hasGiveawayEntry) {
            ticketEntryText = t('giveaway.entered');
            ticketEntryButtonDisabled = true;
        }
        else if (isGiveawayEnded) {
            ticketEntryText = t('giveaway.ended');
            ticketEntryButtonDisabled = true;
        }
        else {
            ticketEntryText = t('giveaway.enter');
            ticketEntryButtonDisabled = false;
        }
    }
    else {
        var isComingSoonFn = (_c = (_b = selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.isComingSoon) === null || _b === void 0 ? void 0 : _b.call(selectedPromotion)) !== null && _c !== void 0 ? _c : false;
        var isEndedFn = (_e = (_d = selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.isEnded) === null || _d === void 0 ? void 0 : _d.call(selectedPromotion)) !== null && _e !== void 0 ? _e : false;
        var isPromotionComingSoon = !draws.length ||
            draws.every(function (d) { return !!d.start && (0, moment_timezone_1.default)(d.start).isAfter(nowToday); }) ||
            isComingSoonFn;
        if (isPromotionComingSoon) {
            ticketEntryText = t('draws.drawStatus.COMING_SOON');
            ticketEntryButtonDisabled = true;
        }
        else {
            ticketEntryText =
                constants_1.default.V2_CHANGES && projectName !== 'KS'
                    ? t('games.submitTicket')
                    : t('games.enterTicket');
            ticketEntryButtonDisabled = isEndedFn;
        }
    }
    var hasWinners = !!drawDetail.latestDrawHistory && drawDetail.latestDrawHistory.winnersPublished;
    var winnersButtonLabel = !!drawDetail.latestDrawHistory && drawDetail.latestDrawHistory.winnersPublished
        ? 'Winners'
        : 'No Winners Yet!';
    React.useEffect(function () {
        getEntities();
        setPrizeCheck(setInterval(updateProgressivePrize, constants_1.default.HOME_SCREEN_FETCH_DRAW_INTERVAL));
        return function () {
            if (prizeCheck) {
                clearInterval(prizeCheck);
            }
            setPrizeCheck(null);
        };
    }, []);
    var updateProgressivePrize = function () {
        if ((selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.promotionType) === types_1.PromotionType.PROGRESSIVE) {
            dispatch((0, actions_2.fetchDetailsPageProgressivePrizes)());
        }
    };
    var getEntities = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch((0, actions_2.fetchPromotionDetails)(identifier));
            dispatch((0, actions_2.fetchDrawWithAdditionalInformation)(Number(identifier)));
            if (isLoggedIn && isGiveaway && giveawayDraws.length !== 0) {
                dispatch((0, actions_2.getGiveawayEntries)(identifier));
            }
            return [2];
        });
    }); };
    var onSelectDraw = function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var isDrawEnded;
        return __generator(this, function (_a) {
            if (item) {
                isDrawEnded = !!item.end && (0, moment_timezone_1.default)(item.end).isBefore(nowToday);
                dispatch((0, actions_2.selectDraw)(item, isDrawEnded));
                if (!isGiveaway && isDrawEnded && !constants_1.default.CHECK_FOR_WINNER_DETAILS) {
                    dispatch((0, actions_2.fetchLatestDrawHistory)(item.id));
                }
                dispatch((0, actions_2.fetchDrawPrizes)(item.id));
                dispatch((0, actions_2.fetchDrawPrizesWithWinners)(item.id));
                if (isLoggedIn) {
                    dispatch((0, actions_3.fetchDrawOptOutPreference)([item.id]));
                    dispatch((0, actions_2.fetchDrawEntries)(item.id));
                }
            }
            return [2];
        });
    }); };
    var onSelectGiveawayDraw = function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var isDrawEnded;
        return __generator(this, function (_a) {
            if (item) {
                isDrawEnded = !!item.drawEnd && (0, moment_timezone_1.default)(item.drawEnd).isBefore(nowToday);
                dispatch((0, actions_2.selectGiveawayDraw)(item, isDrawEnded));
                dispatch((0, actions_2.fetchDrawPrizes)(item.id));
                dispatch((0, actions_2.fetchDrawPrizesWithWinners)(item.id));
                if (isDrawEnded) {
                    dispatch((0, actions_2.fetchLatestDrawHistory)(item.id));
                }
                if (isLoggedIn) {
                    dispatch((0, actions_2.getGiveawayEntriesDetails)(item.id));
                }
            }
            return [2];
        });
    }); };
    var onPreferenceChange = function (optOutArg) {
        dispatch((0, actions_3.submitOptOutDraw)(optOutArg));
    };
    var retrieveContentForDrawPrizes = function (draw) {
        if (draw) {
            dispatch((0, actions_2.fetchDrawPrizesWithContent)(draw.id));
        }
    };
    React.useEffect(function () {
        if (pendingRedirect && isLoggedIn) {
            navigateToTicketEntry();
            setPendingRedirect(false);
        }
    }, [isLoggedIn, pendingRedirect]);
    var navigateToTicketEntry = function () {
        if ((isGiveaway || !isLoggedIn) && constants_1.default.V2_CHANGES) {
            var appNavigate = {
                action: 'LOGIN'
            };
            setPendingRedirect(true);
            framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
        }
        else {
            var appNavigate = {
                action: 'TICKET_ENTRY'
            };
            framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
        }
    };
    var redirectContactUs = function () {
        if (constants_1.default.CUSTOM_CONTACT_US_URL && constants_1.default.CUSTOM_CONTACT_US_URL.length > 0) {
            window.location.href = constants_1.default.CUSTOM_CONTACT_US_URL;
            return;
        }
        var appNavigate = {
            action: 'CONTACT_US'
        };
        framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
    };
    var modalMessage = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (errorMessage != null) {
                dispatch((0, actions_1.showMessageBar)({ message: errorMessage, type: 'error' }));
            }
            return [2];
        });
    }); };
    var firstActiveDraw = function () {
        for (var _i = 0, giveawayDraws_1 = giveawayDraws; _i < giveawayDraws_1.length; _i++) {
            var draw = giveawayDraws_1[_i];
            if (!!draw.drawEnd && (0, moment_timezone_1.default)(draw.drawEnd).isAfter(nowToday)) {
                return draw;
            }
        }
        return giveawayDraws[0];
    };
    var onEnterTicketPress = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isLoggedIn && isGiveaway && !!giveawayDraws && giveawayDraws.length > 0) {
                        if (!hasGiveawayEntry) {
                            dispatch((0, actions_2.postGiveawayEntries)(identifier, 'FREE', account.login, firstActiveDraw(), showPopup));
                        }
                        setTimeout(function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                dispatch((0, actions_2.getGiveawayEntries)(identifier));
                                return [2];
                            });
                        }); }, 1000);
                    }
                    else {
                        navigateToTicketEntry();
                    }
                    return [4, modalMessage()];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var showPopup = function () {
        setShowGiveawayPopup(true);
        if (!!giveawayDraws && giveawayDraws.length > 0) {
            onSelectGiveawayDraw(firstActiveDraw());
        }
    };
    var hideGiveawayPopup = function () {
        setShowGiveawayPopup(false);
    };
    var hideWinnersDialog = function () {
        setShowWinnerDialog(false);
    };
    var hidePrizesDialog = function () {
        setShowPrizesDialog(false);
    };
    var onViewCompletePrizeDescriptionClicked = function () {
        showPrizesContentDialog();
    };
    var showPrizesContentDialog = function () {
        if (retrieveContentForDrawPrizes && giveawayDraw) {
            retrieveContentForDrawPrizes(giveawayDraw);
            setDrawPrizeContentRetrieved(true);
        }
        setShowPrizesDialog(true);
    };
    var retrieveWinnersForDrawPrizes = function (draw) {
        if (draw) {
            dispatch((0, actions_2.fetchDrawPrizesWithWinners)(draw.id));
        }
    };
    var renderDrawTitle = function () {
        if (!!selectedPromotion && Object.keys(selectedPromotion).length > 0) {
            var comingSoon = selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.isComingSoon();
            var promotionEnded = selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.isEnded();
            var endingSoon = selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.isEndingSoon();
            var alert_1 = promotionEnded
                ? 'Promotion Ended'
                : endingSoon
                    ? 'Ending Soon'
                    : comingSoon
                        ? 'Coming Soon'
                        : null;
            return (React.createElement(React.Fragment, null,
                React.createElement(core_1.Grid, { item: true, xs: 12 },
                    React.createElement("div", null,
                        React.createElement("div", { className: classes.header },
                            React.createElement(package_1.Title, { "aria-label": "promotion-title", title: selectedPromotion.name, titleColor: "textPrimary", buttonText: ticketEntryText, buttonTextTitle: ticketEntryText, navigateToTicketEntry: onEnterTicketPress, disabled: ticketEntryButtonDisabled || (isRestricted && isLoggedIn), isRestricted: isRestricted && isLoggedIn, handleContactUs: redirectContactUs, titleComponent: titleComponent })),
                        React.createElement(core_1.Typography, { variant: "h3", className: classes.srOnly, component: "p" },
                            t('giveaway.screenReader.timeline'),
                            selectedPromotion.name,
                            t(ticketEntryText.trim() +
                                ' Button ' +
                                (ticketEntryButtonDisabled ? 'Disabled' : 'Enabled'))))),
                React.createElement(core_1.Grid, { item: true, xs: 12 },
                    React.createElement(core_1.Typography, { variant: "body1", style: {
                            marginBottom: theme.spacing(2),
                            color: colors_1.default.dangerColor.hex()
                        } }, alert_1))));
        }
    };
    var onViewPrizeDetailsAndImagesClicked = function () {
        hideWinnersDialog();
        showPrizesContentDialog();
    };
    var getWinnersDialog = function (draw, dates) { return (React.createElement(package_1.WinnersDialog, { title: "Winners - ".concat(draw === null || draw === void 0 ? void 0 : draw.name), open: showWinnerDialog, drawEndDate: dates.drawEndDate, drawDate: dates.drawDate, drawPrizesWithWinners: retrieveWinnersForDrawPrizes, onClose: hideWinnersDialog, optedOut: undefined, drawStartDate: dates.drawStartDate, onViewPrizeDetailsClicked: onViewPrizeDetailsAndImagesClicked })); };
    var getPrizesDialog = function (draw) {
        var _a;
        return (React.createElement(package_1.PrizesDialog, { title: "Prize Details - ".concat(draw.shortName), open: showPrizesDialog, onClose: hidePrizesDialog, drawPrizeContentRetrieved: drawPrizeContentRetrieved || !retrieveContentForDrawPrizes, drawPrizes: drawDetail.drawPrizes, prizes: (_a = drawDetail.prizes) !== null && _a !== void 0 ? _a : [], draw: draw, selectedPromotion: selectedPromotion }));
    };
    var onViewWinnersClicked = function () {
        if (giveawayDraw)
            retrieveWinnersForDrawPrizes(giveawayDraw);
        setShowWinnerDialog(true);
    };
    var onSubmitTos = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, dispatch((0, actions_4.updateTermsAndConditions)())];
                case 1:
                    _a.sent();
                    return [4, dispatch((0, actions_4.fetchTermsAndConditions)())];
                case 2:
                    _a.sent();
                    setShowTermsOfUseUpdateModal(false);
                    return [2];
            }
        });
    }); };
    var handleTosChecked = function () {
        setTosChecked(!tosChecked);
    };
    if (giveawayErrorMessage) {
        return (React.createElement(core_1.Grid, { item: true, xs: 12, sm: 10, md: 10 },
            React.createElement(core_1.Typography, { variant: "h6", component: "p", style: {
                    textAlign: 'center',
                    paddingTop: theme.spacing(4)
                } },
                React.createElement(Icon_1.default, { iconType: "material", style: {
                        color: colors_1.default.dangerColor.hex(),
                        textAlign: 'center'
                    }, iconName: "error_outline" }),
                giveawayErrorMessage)));
    }
    if (showError) {
        return React.createElement(package_1.LoadError, { onReloadIconPress: getEntities, text: t('giveaway.screenReader.error') });
    }
    if (loading) {
        return (React.createElement(core_1.Grid, { item: true, xs: 12, style: { minHeight: '400px' } },
            React.createElement(package_1.AppSpinner, { label: t('giveaway.screenReader.loading', 'Loading'), customStyles: {
                    backgroundColor: 'transparent'
                } })));
    }
    return (!!selectedPromotion && (React.createElement("div", { className: classes.root },
        React.createElement("section", { "aria-label": "".concat(selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.name, " Draws") },
            React.createElement(package_1.DrawDetail, __assign({ drawDetail: drawDetail, isLoggedIn: isLoggedIn, fetchDrawPrizesWithContent: retrieveContentForDrawPrizes, fetchDrawPrizesWithWinners: retrieveWinnersForDrawPrizes, optOutPreferences: preferences, onPreferenceChange: onPreferenceChange, optOutEntries: optOutEntries, renderTitle: renderDrawTitle, draws: draws, selectDraw: onSelectDraw, selectGiveawayDraw: onSelectGiveawayDraw, selectedPromotion: selectedPromotion, giveawayDraws: giveawayDraws, giveawayEntries: giveawayEntries, isGiveaway: isGiveaway, hideDrawDate: !constants_1.default.SHOW_DRAW_DATE }, (showSuperBonus && ((_f = promotionData === null || promotionData === void 0 ? void 0 : promotionData.superBonusPromotionData) === null || _f === void 0 ? void 0 : _f.games)
                ? {
                    superBonus: {
                        showProgress: isLoggedIn,
                        games: drawDetail.eligibleGames,
                        ticketsRemaining: promotionData.superBonusPromotionData.remainingEntries,
                        totalTickets: promotionData.superBonusPromotionData.totalEntries,
                        superBonusGames: promotionData.superBonusPromotionData.games,
                        onEnterTicketPress: onEnterTicketPress
                    }
                }
                : {}))),
            React.createElement(TermsOfUseUpdateModal_1.default, { show: showTermsOfUseUpdateModal, tosChecked: tosChecked, onSubmitTos: onSubmitTos, handleTosChecked: handleTosChecked })),
        !package_1.config.internalConfig.HIDE_SUBMIT_TICKET_BUTTON && (React.createElement(core_1.Grid, { className: classes.enterTicketButton, item: true, xs: 12 },
            React.createElement(core_1.Button, { size: "large", color: "primary", variant: "contained", "aria-label": ticketEntryText, onClick: onEnterTicketPress, disabled: ticketEntryButtonDisabled || (isRestricted && isLoggedIn) }, projectName === 'KS' ? t('games.enterTicketToGetDrawEntry') : ticketEntryText))),
        !hideEligibleGames && (React.createElement(EligibleGames_1.default, { promotionId: selectedPromotion.id, eligibleGames: drawDetail.eligibleGames })),
        showGiveawayPopup && giveawayDraw && (React.createElement(package_1.InformationDialog, { title: giveawayDraw === null || giveawayDraw === void 0 ? void 0 : giveawayDraw.name, maxWidth: "md", open: showGiveawayPopup, onClose: hideGiveawayPopup, hideButton: true },
            React.createElement(React.Fragment, null,
                isLoggedIn && React.createElement(EntriesBox_1.default, { entries: 1 }),
                React.createElement(core_1.Grid, { item: true, xs: 12 },
                    React.createElement(core_1.Typography, { variant: "body2", color: "textPrimary" }, t('drawDetails.drawNumber') + ': ' + (giveawayDraw === null || giveawayDraw === void 0 ? void 0 : giveawayDraw.shortName)),
                    React.createElement(core_1.Typography, { variant: "body2", color: "textPrimary" }, t('drawDetails.drawStartDate') +
                        ': ' +
                        getGiveawayDrawDates(giveawayDraw).drawStartDate),
                    React.createElement(core_1.Typography, { variant: "body2", color: "textPrimary" }, t('drawDetails.entryEnds') +
                        ': ' +
                        getGiveawayDrawDates(giveawayDraw).drawEndDate),
                    React.createElement(core_1.Typography, { variant: "body2", color: "textPrimary" }, t('drawDetails.drawDate') + ': ' + getGiveawayDrawDates(giveawayDraw).drawDate),
                    React.createElement(React.Fragment, null,
                        React.createElement(core_1.Grid, { item: true, xs: 12, className: classes.prizeDescriptionLink },
                            React.createElement(core_1.Button, { size: "large", variant: "text", color: package_1.config.internalConfig.BUTTON_BACKGROUND, "aria-label": "Prize Information", onClick: onViewCompletePrizeDescriptionClicked, component: "a", className: "linkButton" }, t('drawDetails.prizeInfo'))),
                        React.createElement(core_1.Grid, { item: true, xs: 12, className: classes.winnersBtn, style: { marginBottom: true ? theme.spacing(3) : '' } },
                            React.createElement(core_1.Button, { size: "large", component: !hasWinners ? 'button' : 'a', variant: !hasWinners ? 'contained' : 'text', color: package_1.config.internalConfig.BUTTON_BACKGROUND, disabled: !hasWinners || !drawDetail.drawHistoryRetrieved, "aria-label": winnersButtonLabel, onClick: onViewWinnersClicked, className: !hasWinners ? 'containedButton' : 'linkButton' }, drawDetail.drawHistoryRetrieved ? winnersButtonLabel : 'Loading'))))))),
        giveawayDraw &&
            showWinnerDialog &&
            getWinnersDialog(giveawayDraw, getGiveawayDrawDates(giveawayDraw)),
        giveawayDraw && showPrizesDialog && getPrizesDialog(giveawayDraw))));
};
exports.default = PromotionDetailScreen;
//# sourceMappingURL=index.js.map